import React, { useState, useRef } from "react";
import { CloseRounded } from "@material-ui/icons";
import emailjs from "@emailjs/browser";
import "./BookingModal.css";

const BookingModal = ({ modalOpen, setModalOpen }) => {
  const [inputValues, setInputValues] = useState({
    namn: "",
    email: "",
    telefon: "",
    massage: "",
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs
      .sendForm(
        "service_zrzoy78",
        "template_v5pxpfk",
        form.current,
        "bTz8bG6R8DO3S-Aph"
      )
      .then(
        (result) => {
          if (result.text === "OK") {
            document
              .querySelectorAll("input")
              ?.forEach((el) => (el.value = ""));
            setSending(false);
            setSent(true);
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="booking-modal">
      <div className="close-icon" onClick={() => setModalOpen(false)}>
        <CloseRounded />
      </div>

      <h2 className="title">Kom i kontakt med oss</h2>
      <form ref={form}>
        <input
          type="text"
          name="bookingName"
          placeholder="Namn"
          required
          className="inputs"
          value={inputValues.namn}
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) =>
            (e.target.placeholder = inputValues.namn ? "" : "Namn")
          }
          onChange={(e) => setInputValues({ namn: e.target.value })}
        />
        <input
          type="email"
          name="bookingEmail"
          placeholder="Email"
          required
          className="inputs"
          value={inputValues.email}
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) =>
            (e.target.placeholder = inputValues.namn ? "" : "Email")
          }
          onChange={(e) => setInputValues({ email: e.target.value })}
        />
        <input
          type="text"
          name="bookingTelefon"
          placeholder="Telefon"
          required
          className="inputs"
          value={inputValues.telefon}
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) =>
            (e.target.placeholder = inputValues.namn ? "" : "Telefon")
          }
          onChange={(e) => setInputValues({ telefon: e.target.value })}
        />
        <textarea
          type="text"
          name="bookingMassage"
          placeholder="Meddelande"
          className="massage"
          value={inputValues.massage}
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) =>
            (e.target.placeholder = inputValues.namn ? "" : "Meddelande")
          }
          onChange={(e) => setInputValues({ massage: e.target.value })}
        />
        <button type="submit" onClick={handleSubmit} className="btn">
          {sending ? "skickar..." : sent ? "Tack för din bokning" : "Boka"}
        </button>
      </form>
    </div>
  );
};

export default BookingModal;
